(function () {
    'use strict';

    angular
        .module('actionPlanCriteriaModule')
        .controller('grcActionPlanCriteriaFullController', Controller);

    Controller.$inject = ['$rootScope', '$scope', '$state', 'notificationService', 'followUpService', 'grcActionPlanCriteriaService', 'recomActionPlanUpdateStatusService'];

    function Controller($rootScope, $scope, $state, notificationService, followUpService, grcActionPlanCriteriaService, recomActionPlanUpdateStatusService) {

        $scope.actionPlanCriteria = $scope.boxModel;
        $scope.actionPlan = $scope.boxContext.ActionPlan;
        $scope.ctrlCtxt = {
            isDirty: false
        };

        // Page is dirty
        $scope.pageIsDirty = function () {
            $scope.ctrlCtxt.isDirty = true;
            $rootScope.$broadcast('page-is-dirty');
        };

        // Show Reset Action?
        $scope.showResetAction = function () {
            return $scope.ctrlCtxt.isDirty;
        };

        // Show Delete Action?
        $scope.showDeleteAction = function () {
            return !_.isUndefined($scope.actionPlanCriteria.ActionPlanCriteriaID);
        };

        // Select Owner
        $scope.selectOwner = function (person) {
            $scope.actionPlanCriteria.Owner = person;
            $scope.actionPlanCriteria.OwnerID = person.ItemPersonID;
            $scope.pageIsDirty();
        };
        // Select Owner Delegate
        $scope.selectOwnerDelegate = function (person) {
            $scope.actionPlanCriteria.OwnerDelegate = person;
            $scope.actionPlanCriteria.OwnerDelegateID = person.ItemPersonID;
            $scope.pageIsDirty();
        };

        // Show Save Action?
        $scope.showSaveAction = function (form) {
            if (!$scope.actionPlanCriteria.ActionPlanCriteriaID) return false;

            return $scope.showResetAction(form);
        };

        // Show Add Action?
        $scope.showAddAction = function (form) {
            if ($scope.actionPlanCriteria.ActionPlanCriteriaID) return false;
            if (form.$invalid) return false;

            return true;
        };

        // Reset forms
        $scope.reset = function () {
            $state.reload();
        };

        // Is TargetDate Read Only?
        $scope.isTargetDateReadOnly = function () {
            if ($scope.readOnly) return true;

            return $scope.actionPlanCriteria.IsTargetDateReadOnly;
        };

        // Delete Active Assessment
        $scope.deleteActiveAssessment = function () {
            return grcActionPlanCriteriaService
                    .deleteActiveAssessment($scope.actionPlanCriteria.ActionPlanCriteriaID)
                    .then(function () {
                        $state.reload();
                    });
        }

        // Create Action Plan Criteria
        $scope.createActionPlanCriteria = function () {

            grcActionPlanCriteriaService
                .createActionPlanCriteria($scope.actionPlan.ActionPlanID,
                                  $scope.actionPlanCriteria)
                .then(function (addedActionPlanCriteria) {
                    notificationService.notify('Action Plan has been added');
                    $scope.clickToBack();
                });
        };

        // Update Action Plan
        $scope.updateActionPlanCriteria = function () {

            grcActionPlanCriteriaService
                .updateActionPlanCriteria($scope.actionPlanCriteria)
                .then(function () {
                    notificationService.notify('Your changes have been saved');
                    $state.reload();
                });
        };

        // Delete Action Plan
        $scope.deleteActionPlanCriteria = function () {
            grcActionPlanCriteriaService
                .deleteActionPlanCriteria($scope.actionPlanCriteria)
                .then(function () {
                    $scope.clickToBack();
                });
        }

        // Show open followUps action?
        $scope.showOpenFollowUpsAction = function () {
            if (!$scope.actionPlanCriteria.ActionPlanCriteriaID) return false;

            return !$scope.ctrlCtxt.isDirty;
        };

        // Open Followups
        $scope.openFollowups = function () {
            grcActionPlanCriteriaService
                .getFollowUpListByActionPlanCriteria(
                    $scope.actionPlanCriteria.ActionPlanID,
                    $scope.actionPlanCriteria.ActionPlanCriteriaID)
                .then(function (critAssContainers) {
                    followUpService.openFollowUpsModal($scope.actionPlanCriteria.TitleEN,
                                                      null,
                                                      null,
                                                      critAssContainers,
                                                      getDownloadAttachmentUrl);
                });
        };

        function getDownloadAttachmentUrl(attachmentId, criteriaAssessment) {

            return recomActionPlanUpdateStatusService
                .getDownloadAttachmentUrl(
                    $scope.actionPlanCriteria.RecomBusinessUnitID,
                    $scope.actionPlanCriteria.ActionPlanID,
                    $scope.actionPlanCriteria.ActionPlanCriteriaID,
                    criteriaAssessment.ActionPlanCriteriaAssessmentID,
                    attachmentId);
        }

    }
})();